module.exports = __webpack_public_path__ + "static/media/group_30@3x.59b5016b.jpg";